export const mapOnboardingTemplateToForm = (values = {}) => {
  const apps = [];

  (values.featureSuggestions || []).forEach(feature => {
    const appInstallation = `${feature.appInstallation.id}_${feature.appInstallation.tag}`;
    const foundApp = apps.find(app => app.appInstallation === appInstallation);
    if (foundApp) {
      foundApp.features.push({
        feature: feature.communityAppFeature.appInstallationFeature.tag,
        roles: feature.featureRoleSuggestions.map(
          frs => frs.communityAppFeatureRole.appInstallationFeatureRole.tag
        ),
      });
    } else {
      apps.push({
        appInstallation,
        features: [
          {
            feature: feature.communityAppFeature.appInstallationFeature.tag,
            roles: feature.featureRoleSuggestions.map(
              frs => frs.communityAppFeatureRole.appInstallationFeatureRole.tag
            ),
          },
        ],
      });
    }
  });

  return {
    name: values.name,
    tag: values.tag,
    isInternal: !values.isInternal,
    communityRoles: (values.communityRoleSuggestions || [])
      .map(c => c.communityRole?.tag)
      .filter(c => c),
    version: values.version,
    apps,
  };
};
